import { render, staticRenderFns } from "./_Card.vue?vue&type=template&id=020f38f4"
import script from "./_Card.vue?vue&type=script&lang=js"
export * from "./_Card.vue?vue&type=script&lang=js"
import style0 from "./_Card.vue?vue&type=style&index=0&id=020f38f4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports